import { getClient } from '../core/global-config.js';
import { createAndWaitTask } from '../core/index.js';

export interface VolcesSeededit20Params {
  /** 编辑提示词，必填，长度必须在1-800个字符之间 */
  prompt: string;
  /** Base64编码的图像数据数组，必须包含 exactly 1 个图像 */
  binary_data_base64?: string[];
  /** 图像URL数组，必须包含 exactly 1 个图像 */
  image_urls?: string[];
  /** 随机种子，-1或正整数，默认值为-1 */
  seed?: number;
  /** 编辑强度，范围0-1，默认值为0.5 */
  scale?: number;
  /** 是否返回图像URL */
  return_url?: boolean;
  /** 水印信息 */
  logo_info?: any;
}

export interface VolcesSeededit20Resource {
  type: string;
  url: string;
  size?: number;
  jobId?: string;
}

/**
 * Volces SeedEdit 2.0 Image Editor
 *
 * 通过火山引擎SeedEdit 2.0 API创建图像编辑任务
 *
 * API Documentation: https://www.volcengine.com/docs/86081/1804470
 * @param params 请求参数
 * @returns 生成的资源列表
 */
export async function volcesSeededit20(
  params: VolcesSeededit20Params,
): Promise<VolcesSeededit20Resource[]> {
  const client = await getClient();

  // 该 API 的特定轮询配置
  const pollingOptions = {
    intervalMs: 3000,
    maxAttempts: 60,
  };

  const result = await createAndWaitTask(
    client,
    '/model/v1/generation',
    {
      model: 'volces_seededit_2_0',
      input: [{ params }],
    },
    pollingOptions,
  );

  const resources: VolcesSeededit20Resource[] = [];

  if (result.output) {
    for (const item of result.output) {
      if (item.content) {
        for (const resource of item.content) {
          resources.push({
            type: resource.type || 'image',
            url: resource.url || '',
            size: resource.size,
            jobId: resource.jobId,
          });
        }
      }
    }
  }

  return resources;
}
